import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Icon from "@/components/Icon";
import Reveal from "@/components/Reveal";
import { HOME_SOLUTIONS } from "@/data/site";

export default function SolutionsGrid() {
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="container-cb">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-display text-3xl font-extrabold text-cbink sm:text-4xl">Our Solutions</h2>
            <p className="mt-3 text-[17px] leading-relaxed text-cbslate">
              From strategy to operations, Cloud Beaker delivers end-to-end cloud solutions that
              help you move faster, operate smarter and achieve more.
            </p>
          </div>
          <Link to="/solutions" className="link-arrow shrink-0" data-testid="solutions-viewall">
            View All Solutions <ArrowRight size={16} />
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {HOME_SOLUTIONS.map((s, i) => (
            <Reveal key={s.slug} delay={i * 60}>
              <Link
                to={`/solutions/${s.slug}`}
                data-testid={`solution-card-${s.slug}`}
                className="card-cb group flex h-full flex-col p-7 hover:-translate-y-1 hover:border-primary/30 hover:shadow-cardHover"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-cbblue-soft text-primary transition-colors group-hover:bg-primary group-hover:text-white">
                  <Icon name={s.icon} size={24} />
                </span>
                <h3 className="mt-5 text-lg font-bold text-cbink">{s.title}</h3>
                <p className="mt-2.5 flex-1 text-[15px] leading-relaxed text-cbslate">{s.blurb}</p>
                <span className="mt-5 flex h-9 w-9 items-center justify-center rounded-full border border-border text-primary transition-all group-hover:border-primary group-hover:bg-primary group-hover:text-white">
                  <ArrowRight size={16} />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
